import { jsxs as c, jsx as s } from "@emotion/react/jsx-runtime";
import { BusinessesContentLayout as a, Title as p } from "./BusinessesContent.styled.js";
import { Footer as f } from "./Footer/Footer.js";
import { useBusinessModalContext as d } from "../../BusinessModalContext.js";
import { useBusinesses as h } from "../../hooks/useBusinesses.js";
import { useCountData as B } from "../../hooks/useCountData.js";
import { useIsLoadingBusinessContent as C } from "../../hooks/useIsLoadingBusinessContent.js";
import { Filters as S } from "./Filters/Filters.js";
import { Content as g } from "./Content/Content.js";
import { SelectionType as x } from "../../reducer/businessModal.types.js";
const D = () => {
  const {
    translations: e,
    preFilters: t
  } = d(), o = C(), {
    businesses: n
  } = h(), {
    hasSelectedBusinesses: i,
    hasUnselectedBusinesses: r
  } = B(), m = t?.selection?.type !== x.UNSET, l = i || r || m, u = n.length > 0 || o || l;
  return /* @__PURE__ */ c(a, { children: [
    /* @__PURE__ */ s(p, { variant: "heading4", children: e.selectBusiness }),
    /* @__PURE__ */ s(S, {}),
    /* @__PURE__ */ s(g, {}),
    u && /* @__PURE__ */ s(f, {})
  ] });
};
export {
  D as BusinessesContent
};
